<template>
    <div>
        <div class="flex flex-row header-bar"
            :class="{'header-bar-mobile': headerMobile}">
            <!-- <div class="flex-grow text-left mobile-disclaimer" v-show="headerMobile">Für die beste Vorschau deines Portraits, nutze ein Gerät mit großem Display!</div> -->
            <!-- <div class="flex-grow">
                <div class="header-logo" :class="{'flex': headerMobile}" :style="{'background-image': `url(${mainLogoUrl})`}"></div>
                <div class="header-theme lg:block" v-if="theme.title"
                    :class="{'flex': headerMobile}">
                    Thema: <span class="theme-title">{{ theme.title }}</span>
                </div>
            </div> -->
            <!-- <div class="text-2xl lg:hidden" @click="resetProject"><span class="icon-reset cursor-pointer"></span></div>

            <div class="text-2xl lg:hidden" @click="saveProject"><span v-show="justSaved" class="text-green-500 text-sm align-middle animate-pulse">gespeichert</span><span class="icon-disk cursor-pointer"></span></div> -->

            <!-- <div v-show="step > 0" class="m-1"><a class="btn btn-sm btn-reset" href="#" @click="resetProject">Neu Starten</a></div>

            <div v-show="step > 0 && !justSaved" class="m-1"><a class="btn btn-primary--brand btn-sm" href="#" @click="saveProject">speichern</a></div>

            <div v-show="justSaved" class="m-1 animate-pulse"><a class="btn btn-primary--brand btn-sm" href="#" @click="saveProject">gespeichert</a></div> -->

            <div class="ml-2 cursor-pointer dismiss-modal" data-dismiss="modal"><span class="icon-close"></span></div>
        </div>

    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import Pipeline from '../../Pipeline/Pipeline';

export default {
    props: {
        headerMobile: false
    },
    data() {
        return {
            justSaved: false
        };
    },
    computed: {
        ...mapFields([
            'theme',
            'step'
        ]),
        mainLogoUrl() {
            const mainLogo = document.querySelector('.header-logo-main-img');
            return mainLogo ? mainLogo.src : '';
        }
    },
    methods: {
        async saveProject() {
            // do not save repeatedly
            if(this.justSaved) return;

            await this.$store.commit('saveState');

            this.justSaved = true;

            window.setTimeout(() => {
                this.justSaved = false;
            }, 5000);
        },
        async resetProject() {
            this.$store.state.stage.destroy()
            this.$store.commit('loadState', true);
            Pipeline.runPipeline();
        }
    }
}

</script>
